export enum GameStatusEnum {
	Complete = "complete",
	Live = "live",
	PreGame = "pre_game",
	VoteLive = "vote_live",
}

export enum PositionEnum {
	Def = "DEF",
	Fwd = "FWD",
	Gkp = "GKP",
	Mid = "MID",
}

export enum OrderEnum {
	Asc = "asc",
	Desc = "desc",
}
